import React, { useEffect, useState } from 'react'
import { Button, Divider, Flex, Input, Modal } from 'antd'
import { PhoneOutlined, VideoCameraOutlined, WechatOutlined } from '@ant-design/icons'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { database } from '../../utils/firebase'

const { TextArea } = Input

const CommunicationButtons = ({ chatID, status }) => {
  const navigate = useNavigate()
  const [startChatOpen, setStartChatOpen] = useState(false)
  const [labTracking, setLabTracking] = useState(null)
  const [patientID, setPatientID] = useState(null)
  const doctor = useSelector((state) => state.app.me)
  const [message, setMessage] = useState('')
  const [issue, setIssue] = useState('')
  const location = useLocation()
  const isChatDisabled = location.pathname.includes(`/labedits/${chatID}`) || location.pathname.includes(`/soapnotes/${chatID}`)
  const [prefillMessages] = useState({
    critical: {
      issue: 'Critical issue with immediate attention needed',
      message: 'We are concerned for your heath. And we are following up with you to further discuss.',
    },
    abnormal: { issue: 'Abnormal issue', message: 'Your reports are abnormal.' },
  })

  const fetchLabDetails = async () => {
    const snapshot = await database.ref(`labTracking/${chatID}`).once('value')
    const response = snapshot.val()
    if (response) {
      setLabTracking(response)
      if (response.patientID) {
        setPatientID(response.patientID)
      } else {
        window.alert('No patient ID found')
      }
    }
  }

  useEffect(() => {
    fetchLabDetails()
  }, [chatID])

  useEffect(() => {
    if (startChatOpen && status) {
      const prefill = prefillMessages[status] || { issue: '', message: '' }
      setIssue(prefill.issue)
      setMessage(prefill.message)
    }
  }, [startChatOpen, status, prefillMessages])

  const handleChat = async () => {
    const _chatID = chatID.replace('_labs', '').replace('_imaging', '')

    const patientHasPHDChat = await database.ref(`users/${patientID}/conversations`).once('value').then(s => s.exists())
    //  const patientHasChat = await database.ref(`openconversations/${_chatID}`).once('value').then(s => s.exists())


    /* const pdrChatID = await database
       .ref(`labTracking/${chatID}/conversationID`)
       .once('value')
       .then((snapshot) => {
         if (snapshot.exists()) {
           return snapshot.val() // This returns the value stored against conversationID
         } else {
           return null
         }
       })
       .catch((error) => {
         console.error('Error fetching conversationID: ', error)
         return null // Return null or handle error
       })

     console.log('chat from pdr', pdrChatID)*/

    /*  const activeChatInOpenConversation = await database
        .ref(`openconversations/${pdrChatID}`)
        .once('value')
        .then((snapshot) => {
          if (snapshot.exists()) {
            // If the conversation with pdrChatID exists in openconversations
            return true // or handle the logic if chat is active
          } else {
            // If the conversation doesn't exist in openconversations
            return false // or handle the logic if chat is not active
          }
        })
        .catch((error) => {
          console.error('Error checking open conversations:', error)
          return false // In case of error, treat as chat not active
        })*/
    if (labTracking?.conversationID) {
      if (activeChatInOpenConversation) {
        navigate(`/chat/${chatID}`, { replace: true })
      }

    } else {
      if (patientHasPHDChat) {
        window.alert('Chat active on PHD')
        return
      }
      setStartChatOpen(true)
    }
  }

  const handleSubmit = async () => {
    try {
      const conversationID = database.ref('conversations').push().key
      const messageID = database.ref(`conversations/${conversationID}`).push().key
      const _message = {
        isRead: false,
        toID: patientID,
        fromID: doctor.id,
        type: 'text',
        content: message,
        timestamp: new Date().getTime(),
        doctorImgURL: doctor.profileImageURL,
        doctorName: doctor.doctorName,
      }
      const userConversation = {
        tier2: false,
        callEnabled: true,
        location: conversationID,
        timestamp: new Date().getTime(),
        clinic_id: null,
        category: issue,
        symptoms: issue,
        clinical_chat: false,
        categories: issue,
        owner: null,
        issue,
        selectedClinic: null,
        tier2ClinicData: null,
      }
      const openConversation = {
        status: true,
        paidChat: true,
        callEnabled: true,
        clinical_chat: null,
        clinical_to_skip: false,
        purpose: 'lab requisition',
        owner: null,
        tier2: false,
        doctorID: doctor.id,
        doctorName: doctor.doctorName,
        timestamp: new Date().getTime(),
        patientID,
        referralChat: null,
        referralFromApp: null,
        category: issue,
        queued: false,
        isEMRChat: false,
        categories: issue,
        fromConsumable: false,
        issue,
        patientName: labTracking?.patientName || '',
        labTrackingID: chatID,
      }

      const updates = {}
      updates[`conversations/${conversationID}/${messageID}`] = _message
      updates[`users/${patientID}/conversations`] = userConversation
      updates[`openconversations/${conversationID}`] = openConversation
      updates[`labTracking/${chatID}/conversationID`] = conversationID

      await database.ref().update(updates)
      setStartChatOpen(false)
      navigate(`/chat/${chatID}`, { replace: true })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <Flex gap="middle" justify="center" align="center" style={{ padding: '6px' }}>
        <Button onClick={handleChat} style={{ padding: '0px 48px', backgroundColor: '#5CCB18' }}
                icon={<WechatOutlined />} disabled={isChatDisabled} />
        <Modal title="Start new Chat" open={startChatOpen} onOk={handleSubmit} onCancel={() => setStartChatOpen(false)}>
          <div className="alert alert-warning d-flex align-items-center" role="alert">
            <span>
              You are about to initiate a new chat with patient <strong>{labTracking?.patientName}</strong>, which will be assigned to you ({doctor.doctorName}). Please remember to close the chat from the Doctors Dashboard when necessary.
            </span>
          </div>
          <Flex vertical>
            Issue:
            <Input placeholder="Describe your issue here" value={issue} onChange={(e) => setIssue(e.target.value)} />
          </Flex>
          <Flex vertical>
            Message:
            <TextArea rows={4} value={message} onChange={(e) => setMessage(e.target.value)} />
          </Flex>
        </Modal>
        <Button style={{ padding: '0px 48px', backgroundColor: '#5CCB18' }} icon={<PhoneOutlined />} disabled />
        <Button style={{ padding: '0px 48px', backgroundColor: '#5CCB18' }} icon={<VideoCameraOutlined />} disabled />
      </Flex>
      <Divider style={{ margin: 0 }} />
    </>
  )
}

export default CommunicationButtons
